import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SppdashboardService } from '../view/dashboard/sppdashboard.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class authGuard implements CanActivate {

  message: any;
  subscription: any;
  status: boolean = false
  email:any;


  constructor(private _sppdashboard: SppdashboardService, private _auth: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    this._sppdashboard.getUser().subscribe((response: any) => {

      this._auth.setLoggedInUserDetails(response.data);
      // console.log("#userdetails-guard", response.data);
      this._auth.changeMessage(response.data);
      this.email = response.data.email;

      this._sppdashboard.userexist(this.email).subscribe((res: any) => {
       this._auth.changeStatus(res.data);
      })
      this.status = true;
      return true
    }
    );


    this._auth.currentStatus.subscribe((res: any) => {

      if(res.status === 'FIRST_LOGIN'||res.status === 'OPEN'||res.status === 'REJECT'){
        if(state.url === '/dashboard'){
          this.status =  true;
         }
        }

      else if(res.status === 'ACTIVE_MCT' || res.status === 'RENEWAL' || res.status === 'REINSTATE_SUBMIT' || res.status === 'RENEWAL_REJECT' || res.status === 'REINSTATE_REJECT' || res.status === 'RENEWAL_APPROVE' || res.status === 'APPROVE' || res.status === 'REINSTATE_APPROVE' || res.status === 'EXPIRED') {

       if(state.url === '/alumni-request' ||state.url === '/home'||state.url === '/mycompany'||state.url === '/support'||state.url === '/emailupdate'||state.url === '/profile') {
        this.status =  true;
       }
      }

      else if(res.status === 'ACTIVE_MCT' || res.status === 'RENEWAL_REJECT' || res.status === 'RENEWAL' || res.status === 'REINSTATE_SUBMIT' || res.status === 'REINSTATE_REJECT' || res.status === 'EXPIRED'){
           if(state.url === '/vouchers' || state.url === '/classes' || state.url === '/announcement'){ 
            this.status =  true;
           }
      }

       else if(res.status === 'ACTIVE_MCT' || res.status === 'RENEWAL_REJECT' || res.status === 'RENEWAL' || res.status === 'RENEWAL_APPROVE'){
           if(state.url === '/tech-communities' || state.url === '/extreme-labs' || state.url === '/vss' || state.url ==='/courseware'){ 
            this.status =  true;
           }
      }

      else if(res.status === 'RENEWAL_APPROVE' || res.status === 'APPROVE' || res.status === 'REINSTATE_APPROVE'){
           if(state.url === '/live'){ 
            this.status =  true;
           }
      }

    })

     if (this.status) {
      return true;
    } else {
        //this.router.navigate(['/home']);
        if(state.url === '/home'|| state.url === '/dashboard' || state.url === '/terms'||state.url === '/expired-mct'||state.url === '/vouchers') {
          return true;
        }
       //setTimeout(() => { 
       
          this.router.navigate(['/login']);
        //},1000)
         //return true;
      //}
         // this.router.navigate(['/login']);
        //}
        return false;
     
    }


    //this.subscription = this._auth.currentMessage.subscribe(message => {
      // this.message = message;
      // console.log("#subject respnse", message);
    //});

    // console.log("#sttaus", this.status);

   
  }
}